import { serialize, parse } from 'cookie';
var sessionKey = 'sessionRcx';
export function setSessionCookie() {
    var data = serialize(sessionKey, Date.now());
    document.cookie = data;
    return +parse(data)[sessionKey];
}
export function getSessionCookieValue() {
    var sessionStart = +parse(document.cookie)[sessionKey];
    if (!sessionStart) {
        return setSessionCookie();
    }
    return sessionStart;
}
